import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import { format } from "date-fns";
import { useNavigate } from "react-router-dom";
import { appendTrackingParams } from "../../shared-utils/trackingUtils";
import { ZILLOUT_WEB_BASE_URL } from "../../config/urls";
export default function SlotPillsGrid({ eventId, slots, onSlotChange, appContext = "customer", selectedIdx, }) {
    const sortedSlots = [...slots].sort((a, b) => new Date(a.start_time).getTime() - new Date(b.start_time).getTime());
    const [selected, setSelected] = useState(selectedIdx !== undefined ? selectedIdx : null);
    const navigate = useNavigate();
    // Sync with external selectedIdx prop changes
    useEffect(() => {
        if (selectedIdx !== undefined) {
            setSelected(selectedIdx);
        }
    }, [selectedIdx]);
    const handleRoutes = (route) => {
        if (appContext === "experience") {
            navigate(-1);
            setTimeout(() => {
                window.open(appendTrackingParams(`${ZILLOUT_WEB_BASE_URL}${route}`), "_self");
            }, 10);
        }
        else {
            navigate(route);
        }
    };
    const isSlotEnded = (endTime) => {
        return new Date(endTime) < new Date();
    };
    return (_jsx(Flex, { gap: 4, pt: 6, pb: 10, px: 5, flexWrap: "wrap", w: "100%", children: sortedSlots.map((slot, idx) => {
            const ended = isSlotEnded(slot.end_time);
            const isDisabled = ended;
            const isSelected = selected === slot.id;
            return (_jsxs(Box, { borderRadius: 12, border: "1px solid #363636", bg: isSelected ? "#232323" : "#181818", color: isSelected ? "#A383FF" : "#A383FF", boxShadow: isSelected ? "0 0 0 2px #A383FF" : undefined, px: 4, py: 2, cursor: isDisabled ? "not-allowed" : "pointer", w: "fit-content", onClick: () => {
                    if (isDisabled)
                        return;
                    setSelected(slot.id);
                    if (onSlotChange) {
                        onSlotChange(slot);
                    }
                    else {
                        // Delay navigation to show selection state
                        setTimeout(() => {
                            handleRoutes(`/event/booking/${eventId}?direct_slot=${slot.name}_${slot.id}`);
                        }, 100);
                    }
                }, transition: "all 0.2s", opacity: isDisabled ? 0.5 : 1, _hover: {
                    bg: isDisabled ? undefined : isSelected ? "#232323" : "#232323",
                }, children: [_jsx(Flex, { align: "center", justify: "space-between", gap: 2, mb: 1, children: _jsxs(Text, { color: "#A383FF", fontSize: "10px", fontWeight: 400, children: [slot.name || `Slot ${idx + 1}`, isDisabled && " (Ended)"] }) }), _jsxs(Text, { color: "white", fontSize: "xs", fontWeight: 500, children: [format(new Date(slot.start_time), "hh:mm a"), " -", " ", format(new Date(slot.end_time), "hh:mm a")] })] }, slot.id));
        }) }));
}
